import { showToast } from '@lokalise/louis';

const showAuthToast = ({ title }: { title: string }) => showToast({ title, type: 'info', autoClose: 5000 });

const showUnexpectedAuthErrorToast = () =>
    showToast({
        title: 'Something went wrong, please contact support via chat or hello@lokalise.com',
        type: 'error',
        autoClose: 5000,
    });

export default showAuthToast;

export { showUnexpectedAuthErrorToast };
